"use client";

import * as React from "react";
import styled from "styled-components";
import ItinerarySegmentBanner from "./ItinerarySegment/ItinerarySegmentBanner";
import ItineraryBadgeList, { ItineraryBadgeListItem } from "./ItineraryBadgeList";
import ItinerarySegment from "./ItinerarySegment";
import ItinerarySeparator from "./ItinerarySeparator";
import ItineraryStatus from "./ItineraryStatus";
import ItinerarySegmentStop from "./ItinerarySegment/ItinerarySegmentStop";
import ItinerarySegmentDetail from "./ItinerarySegment/ItinerarySegmentDetail";
import defaultTheme from "../defaultTheme";
import getSpacingToken from "../common/getSpacingToken";
import { ItineraryProvider } from "./context";
const StyledItineraryWrapper = styled.div.withConfig({
  displayName: "Itinerary__StyledItineraryWrapper",
  componentId: "sc-1x1s9pq-0"
})(["margin-bottom:", ";"], getSpacingToken);
StyledItineraryWrapper.defaultProps = {
  theme: defaultTheme
};
const Itinerary = ({
  children,
  dataTest,
  spaceAfter,
  id
}) => {
  return /*#__PURE__*/React.createElement(StyledItineraryWrapper, {
    "data-test": dataTest,
    id: id,
    spaceAfter: spaceAfter
  }, /*#__PURE__*/React.createElement(ItineraryProvider, null, children));
};
export { ItinerarySegment, ItinerarySegmentBanner, ItinerarySegmentDetail, ItinerarySegmentStop, ItinerarySeparator, ItineraryBadgeList, ItineraryBadgeListItem, ItineraryStatus };
export default Itinerary;